<template>
    <svg :width="size" :height="size" :viewBox="`0 0 19 19`" fill="none" xmlns="http://www.w3.org/2000/svg" class="sellia-icon-two-four-pointed-star">
        <path
            d="M7.43796 18.6077C7.40886 18.701 7.35279 18.7822 7.27773 18.8397C7.20266 18.8973 7.11242 18.9282 7.01982 18.9282C6.92723 18.9282 6.83699 18.8973 6.76192 18.8397C6.68686 18.7822 6.63079 18.701 6.60168 18.6077L5.81615 16.1045C5.46499 14.9886 4.64089 14.114 3.58945 13.7413L1.23082 12.9076C1.14292 12.8768 1.06642 12.8172 1.01221 12.7376C0.95799 12.6579 0.92881 12.5621 0.92881 12.4639C0.92881 12.3656 0.95799 12.2698 1.01221 12.1902C1.06642 12.1105 1.14292 12.051 1.23082 12.0201L3.58945 11.1864C4.10802 11.0031 4.57922 10.6941 4.96571 10.2839C5.35221 9.87368 5.64338 9.3736 5.81615 8.82325L6.60168 6.32005C6.63079 6.22676 6.68686 6.14558 6.76192 6.08804C6.83699 6.03051 6.92723 5.99953 7.01983 5.99953C7.11242 5.99954 7.20266 6.03051 7.27773 6.08804C7.35279 6.14558 7.40886 6.22676 7.43797 6.32005L8.2235 8.82325C8.39627 9.3736 8.68744 9.87368 9.07394 10.2839C9.46043 10.6941 9.93163 11.0031 10.4502 11.1864L12.8088 12.0201C12.8967 12.051 12.9732 12.1105 13.0274 12.1902C13.0817 12.2698 13.1108 12.3656 13.1108 12.4639C13.1108 12.5622 13.0817 12.6579 13.0274 12.7376C12.9732 12.8173 12.8967 12.8768 12.8088 12.9076L10.4502 13.7413C9.93163 13.9247 9.46043 14.2337 9.07394 14.6439C8.68744 15.0541 8.39627 15.5542 8.2235 16.1045L7.43796 18.6077Z"
            :fill="color" />
        <path
            d="M15.7776 7.93277C15.7614 7.9846 15.7303 8.0297 15.6886 8.06167C15.6469 8.09363 15.5967 8.11084 15.5453 8.11084C15.4939 8.11084 15.4437 8.09363 15.402 8.06167C15.3603 8.0297 15.3292 7.9846 15.313 7.93277L14.8766 6.54211C14.6815 5.92217 14.2237 5.43628 13.6395 5.22923L12.3292 4.76608C12.2804 4.74891 12.2379 4.71585 12.2077 4.6716C12.1776 4.62734 12.1614 4.57413 12.1614 4.51954C12.1614 4.46494 12.1776 4.41174 12.2077 4.36748C12.2379 4.32322 12.2804 4.29016 12.3292 4.273L13.6395 3.80984C13.9276 3.70798 14.1894 3.5363 14.4041 3.30842C14.6188 3.08054 14.7806 2.80272 14.8766 2.49697L15.313 1.1063C15.3292 1.05447 15.3603 1.00937 15.402 0.977408C15.4437 0.945442 15.4939 0.928236 15.5453 0.928236C15.5967 0.928236 15.6469 0.945442 15.6886 0.977408C15.7303 1.00937 15.7614 1.05447 15.7776 1.1063L16.214 2.49697C16.31 2.80272 16.4718 3.08054 16.6865 3.30842C16.9012 3.5363 17.163 3.70798 17.4511 3.80984L18.7614 4.273C18.8103 4.29016 18.8527 4.32322 18.8829 4.36748C18.913 4.41174 18.9292 4.46494 18.9292 4.51954C18.9292 4.57413 18.913 4.62734 18.8829 4.6716C18.8527 4.71586 18.8103 4.74891 18.7614 4.76608L17.4511 5.22923C17.163 5.3311 16.9012 5.50277 16.6865 5.73065C16.4718 5.95854 16.31 6.23636 16.214 6.54211L15.7776 7.93277Z"
            :fill="color" />
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#FBFBFB'
        },
        size: {
            type: String,
            default: "19"
        },
        hoverColor: {
            type: String,
            default: 'white'
        }
    }
}
</script>


<style> 

.sellia-icon-two-four-pointed-star:hover path {
    fill: v-bind(hoverColor);
}

</style>
